import { getGridStringOperators } from '@mui/x-data-grid';

export const getFilterOperators = (operators: string[]) =>
  getGridStringOperators().filter(({ value }) => operators.includes(value));
